<!-- Total Bookings -->
<div class="p-2 flex align-items-center justify-content-between text-sm" data-testid="total-bookings-section">
  <span class="text-800" *ngIf="!showSkeleton" data-testid="total-bookings-count">
    <div [innerHTML]="'CLIENT_BOOKING.TOTAL_BOOKINGS' | translate :{count: getTotakBookings() }">
    </div>
  </span>
  <p-skeleton *ngIf="showSkeleton" height="1.35rem" styleClass="w-10rem" data-testid="total-bookings-skeleton"></p-skeleton>
  <div class="text-right">
    <button pButton pRipple type="button" icon="fa fa-plus" *ngIf="!showSkeleton"
      (click)="showBookAppointmentPopup=true" class="text-sm"
      aria-label="schedule-appointment-button" data-testid="schedule-appointment-button" [label]="'CLIENT_BOOKING.BTN_SCHEDULE' | translate">
    </button>
    <p-skeleton *ngIf="showSkeleton" height="2rem" data-testid="schedule-button-skeleton"></p-skeleton>
  </div>
</div>
<!-- Total Bookings -->

<!-- Appointments -->
<div class="px-2" data-testid="appointments-section">

  <!-- Details -->
  <div class="text-sm mt-3">
    <div class="surface-0 border-1 border-300 shadow-1 border-round" data-testid="subscriptions-table-container">

      <!-- Table -->
      <p-table [value]="Subscriptions$ | async" styleClass="p-0" responsiveLayout="scroll" 
        aria-label="subscriptions-table" data-testid="subscriptions-table">
        <ng-template pTemplate="header">
          <tr>
            <th class="surface-100"><span class="text-xs text-600 white-space-nowrap"
                data-testid="booking-type-header">{{'CLIENT_BOOKING.BOOKING_TYPE' | translate}}</span>
            </th>
            <th class="surface-100"><span class="text-xs text-600 white-space-nowrap"
                data-testid="total-header">{{'CLIENT_BOOKING.TOTAL' | translate}}</span></th>
            <th class="surface-100"><span class="text-xs text-600 white-space-nowrap"
                data-testid="used-header">{{'CLIENT_BOOKING.USED' | translate}}</span></th>
            <th class="surface-100"><span class="text-xs text-600 white-space-nowrap"
                data-testid="booked-header">{{'CLIENT_BOOKING.BOOKED' | translate}}</span></th>
            <th class="surface-100"><span class="text-xs text-600 white-space-nowrap"
                data-testid="no-show-header">{{'CLIENT_BOOKING.NO_SHOW' | translate}}</span></th>
            <th class="surface-100"><span class="text-xs text-600 white-space-nowrap"
                data-testid="available-header">{{'CLIENT_BOOKING.AVAILABLE' | translate}}</span></th>
            <th class="surface-100"><span class="text-xs text-600 white-space-nowrap"
                data-testid="activation-date-header">{{'CLIENT_BOOKING.ACTIVATION_DATE' | translate}}</span>
            </th>
            <th class="surface-100"><span class="text-xs text-600 white-space-nowrap"
                data-testid="expiry-date-header">{{'CLIENT_BOOKING.EXPIRY_DATE' | translate}}</span>
            </th>
            <th class="surface-100"><span class="text-xs text-600 white-space-nowrap"
                data-testid="status-header">{{'CLIENT_BOOKING.STATUS' | translate}}</span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tableData>
          <tr class="text-sm">
            <td class="py-3 white-space-nowrap align-items-center" data-testid="booking-type-cell">
              <strong>{{tableData.service_category_name_primary_language}}</strong>
            </td>
            <td class="py-3 white-space-nowrap align-items-center" data-testid="total-cell">{{tableData.total_sessions}}</td>
            <td class="py-3 white-space-nowrap align-items-center" data-testid="used-cell">{{tableData.used_sessions}}</td>
            <td class="py-3 white-space-nowrap align-items-center" data-testid="booked-cell">{{tableData.booked_sessions}}</td>
            <td class="py-3 white-space-nowrap align-items-center" data-testid="no-show-cell">{{tableData.noshow_sessions}}</td>
            <td class="py-3 white-space-nowrap align-items-center" data-testid="available-cell">{{tableData.available_sessions}}</td>
            <td class="py-3 white-space-nowrap align-items-center" data-testid="activation-date-cell">{{tableData.activation_date | datetimeformat : 'dd MMM yy'}}</td>
            <td class="py-3 white-space-nowrap align-items-center" data-testid="expiry-date-cell">{{tableData.expiry_date | datetimeformat : 'dd MMM yy' }}</td>
            <td class="py-3 white-space-nowrap" data-testid="status-cell">
              <p-tag *ngIf="getStatus(tableData.activation_date, tableData.expiry_date) as res"
                styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap cursor-pointer"
                severity="{{res.severity}}">{{res.status}}</p-tag>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <!-- Table -->
    </div>
  </div>
  <!-- Details -->

  <!-- Upcoming Bookings -->
  <div class="text-sm mt-3" data-testid="upcoming-bookings-section">
    <div class="surface-0 border-1 border-300">
      <div class="p-3">
        <h6 class="text-sm mb-0" data-testid="upcoming-bookings-header"
          [innerHTML]="'CLIENT_BOOKING.UPCOMING_BOOKINGS' | translate :{count : (futureClassAppointmentList | async).length}">
        </h6>
      </div>

      <div class="" *ngIf="(futureClassAppointmentList | async).length === 0">
        <p-message severity="info" styleClass="relative" aria-label="no-upcoming-bookings-message" data-testid="no-upcoming-bookings-message">
            <div class="flex align-items-center w-full -my-2 md:m-0">
              <i class="fa fa-info-circle text-xl"></i>
              <div class="ml-2 text-xs md:text-sm pr-5">
                <span
                  [innerHTML]="'CLIENT_BOOKING.DATA_FROM_RANGE' | translate :{start_date : loadingfutureStartDate | date:'dd MMM yy', end_date:loadingfutureEndDate | date:'dd MMM yy'}"></span>
              </div>
            </div>
        </p-message>
      </div>

      <app-data-grid [columnData]="futureClassAppointmentList" [columns]="columns" [loading]="loading  | async"
        [EmptyState]="emptyStateComponent$" [selectable]="false" [selectable]="false" (onAction)="onActionEvent($event)"
        tableClasses="shadow-2 p-0" [headerClasses]="'text-xs text-600 white-space-nowrap'" [paginator]="false"
        [EmptyStateClass]="'pt-1 pb-2 text-center surface-0'" [loading]="loading" [gridName]="'upcoming-bookings-list'" aria-label="upcoming-bookings-table" data-testid="upcoming-bookings-table">
      </app-data-grid>

      <div class="text-center py-3 mb-3">
        <p-button [loading]="futureLoading" [label]="'CLIENT_BOOKING.LOAD_MORE_UPCOMING' | translate"
          icon="fa fa-refresh" styleClass="text-sm p-button-outlined" (onClick)="getFutureData()"
          aria-label="load-more-upcoming-button" data-testid="load-more-upcoming-button">
        </p-button>
      </div>
    </div>
  </div>
  <!-- Upcoming Bookings -->

  <!-- Past Bookings -->
  <div class="text-sm mt-3" data-testid="past-bookings-section">
    <div class="surface-0 border-1 border-300">
      <div class="p-3">
        <h6 class="text-sm mb-0" data-testid="past-bookings-header"
          [innerHTML]="'CLIENT_BOOKING.PAST_BOOKINGS' | translate :{count : (pastClassAppointmentList | async).length}">
        </h6>
      </div>

      <div class="" *ngIf="(pastClassAppointmentList | async).length === 0">
        <p-message severity="info" styleClass="relative" aria-label="no-past-bookings-message" data-testid="no-past-bookings-message">
            <div class="flex align-items-center w-full -my-2 md:m-0">
              <i class="fa fa-info-circle text-xl"></i>
              <div class="ml-2 text-xs md:text-sm pr-5">
                <span *ngIf="isPastBookingClicked"
                  [innerHTML]="'CLIENT_BOOKING.DATA_FROM_RANGE' | translate :{start_date :loadingPastEndDate | date:'dd MMM yy', end_date:pastCurrentDate | date:'dd MMM yy'}">
                </span>
                <span *ngIf="!isPastBookingClicked"
                  [innerHTML]="'CLIENT_BOOKING.DATA_FROM_RANGE' | translate :{start_date :loadingPastStartDate | date:'dd MMM yy', end_date:loadingPastEndDate | date:'dd MMM yy'}">
                </span>
              </div>
            </div>
        </p-message>
      </div>

      <app-data-grid [columnData]="pastClassAppointmentList" [columns]="columns" [loading]="loading  | async"
        [EmptyState]="emptyStateComponent$" [selectable]="selectable" [selectionMode]="'single'"
        (onAction)="onActionEvent($event)" (emitValue)="handleTableEvent($event)" tableClasses="shadow-2 p-0"
        [headerClasses]="'text-xs text-600 white-space-nowrap'" [paginator]="false"
        [EmptyStateClass]="'pt-1 pb-2 text-center surface-0'" [loading]="loading" [gridName]="'past-bookings-list'" aria-label="past-bookings-table" data-testid="past-bookings-table">
      </app-data-grid>

      <div class="text-center py-3">
        <p-button [loading]="pastLoading" [label]="'CLIENT_BOOKING.LOAD_MORE_PAST' | translate" icon="fa fa-refresh"
          styleClass="text-sm p-button-outlined" (onClick)="getPastData()"
          aria-label="load-more-past-button" data-testid="load-more-past-button">
        </p-button>
      </div>
    </div>
  </div>
  <!-- Past Bookings -->

</div>

<!-- Comp Session -->
<p-dialog [(visible)]="compSession" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal overflow-visible"
  aria-label="complimentary-session-dialog" data-testid="complimentary-session-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <form [formGroup]="complimentoryForm">
      <!-- Header -->
      <div class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300">
        <h2 class="mb-0 text-base md:text-lg" data-testid="dialog-header">{{'CLIENT_BOOKING.HEADER' | translate}} </h2>
        <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="resetForm()"
          aria-label="close-dialog-button" data-testid="close-booking-tab-dialog-button"></div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 text-sm p-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="reason-label">{{'CLIENT_BOOKING.COMP_REASON' | translate}}</label>
        <textarea pInputTextarea class="w-full h-5rem" formControlName="comments"
          [placeholder]="'CLIENT_BOOKING.COMP_REASON_PLACEHOLDER' | translate"
          aria-label="reason-textarea" data-testid="reason-textarea">
        </textarea>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
        <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-text text-sm" (click)="resetForm()"
          aria-label="cancel-button" data-testid="cancel-booking-tab-dialog-button">
        </button>
        <button pButton pRipple type="button" [label]="'CLIENT_BOOKING.COMP_SESSION' | translate" class="text-sm"
          (click)="ComplimentoryClass(complimentoryForm)" [loading]="isComplimentoryLoading"
          aria-label="submit-button" data-testid="submit-button">
        </button>
      </div>
      <!-- Modal Footer -->
    </form>

  </ng-template>

</p-dialog>
<!-- Comp Session -->

<!-- Delete Appointment Modal -->
<p-dialog [(visible)]="cancelAppointment" (onHide)="resetForm()" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '470px'}" styleClass="no-header-modal"
  aria-label="cancel-appointment-dialog" data-testid="cancel-appointment-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <form [formGroup]="deleteAppointmentForm">
      <!-- Content -->
      <div class="relative text-center px-4 py-5">
        <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="resetForm()" aria-label="close-dialog-button" data-testid="close-dialog-button">
        </div>

        <i class="fa fa-exclamation-triangle p-error text-7xl mt-5"></i>

        <h4 class="text-base md:text-lg mb-2 mt-5 mb-0 font-bold" data-testid="confirmation-message">
          {{'SCHEDULE.VIEWAPPOINTMENT.CANCEL_CONFIM' | translate}} <br>
          {{appointmentObject!.type_name_primary_language }}
          {{'CLIENT_BOOKING.FOR' | translate }} {{appointmentObject.start_datetime | datetimeformat:"mediumDate"}} ?
        </h4>
      </div>

      <div class="px-4 pt-4 pb-3 border-top-1 border-300">
        <h4 class="font-medium text-center text-700 text-xs mb-2 block uppercase" data-testid="reason-label">
          {{'SCHEDULE.VIEWAPPOINTMENT.CANCEL_REASON' | translate}}
        </h4>
        <textarea pInputTextarea class="w-full text-sm h-7rem mb-3" formControlName="cancellation_reason"
          placeholder="{{'SCHEDULE.VIEWAPPOINTMENT.CANCEL_REASON' | translate}}"
          aria-label="reason-textarea" data-testid="reason-textarea">
        </textarea>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
        <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-secondary p-button-text text-sm" (click)="resetForm()"
          aria-label="cancel-button" data-testid="cancel-button">
        </button>
        <button pButton pRipple type="button" [label]="'SCHEDULE.VIEWAPPOINTMENT.CONTINUE' | translate"
          class="p-button-danger text-sm" (click)="CancelAppointment(deleteAppointmentForm)"
          aria-label="continue-button" data-testid="continue-button">
        </button>
      </div>
      <!-- Modal Footer -->
    </form>

  </ng-template>

</p-dialog>
<!-- Delete Appointment Modal -->


<view-appointment *ngIf="viewAppointmentSidebar" [visible]="viewAppointmentSidebar"
  (CloseViewAppointment)="CloseViewAppointment($event)" [appointmentData]="appointmentObject!" [eventData]="eventObject"
  [tenantId]="tenantId" (emitUpdatedData)="handleEvent($event)"
  aria-label="view-appointment-sidebar" data-testid="view-appointment-sidebar">
</view-appointment>

<book-appointment *ngIf="showBookAppointmentPopup" [visible]="showBookAppointmentPopup" [clientId]="clientId"
  [startDateTime]="selectedDateTime" [tenantId]="tenantId" (CloseBookAppointment)="CloseBookAppointment($event)"
  (reloadData)="reloadEvents($event)"
  aria-label="book-appointment-dialog" data-testid="book-appointment-dialog">
</book-appointment>